"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errors = void 0;
const core_1 = require("@smash-sdk/core");
const GetUsageError_1 = require("./types/GetUsage/GetUsageError");
const GetUsageError_2 = require("./types/GetUsage/GetUsageError");
const GetUsageError_3 = require("./types/GetUsage/GetUsageError");
const GetUsageError_4 = require("./types/GetUsage/GetUsageError");
const GetUsageError_5 = require("./types/GetUsage/GetUsageError");
const GetUsageError_6 = require("./types/GetUsage/GetUsageError");
const GetUsageError_7 = require("./types/GetUsage/GetUsageError");
const GetUsageError_8 = require("./types/GetUsage/GetUsageError");
exports.errors = {
    GetUsage: {
        InvalidParameterError: GetUsageError_2.InvalidParameterError,
        UnauthorizedError: GetUsageError_3.UnauthorizedError,
        InvalidKeyError: GetUsageError_4.InvalidKeyError,
        ForbiddenError: GetUsageError_5.ForbiddenError,
        InternalServerError: GetUsageError_6.InternalServerError,
        BadGatewayError: GetUsageError_7.BadGatewayError,
        GatewayTimeoutError: GetUsageError_8.GatewayTimeoutError,
        GenericError: GetUsageError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    GetUsageError: {
        InvalidParameterError: GetUsageError_2.InvalidParameterError,
        UnauthorizedError: GetUsageError_3.UnauthorizedError,
        InvalidKeyError: GetUsageError_4.InvalidKeyError,
        ForbiddenError: GetUsageError_5.ForbiddenError,
        InternalServerError: GetUsageError_6.InternalServerError,
        BadGatewayError: GetUsageError_7.BadGatewayError,
        GatewayTimeoutError: GetUsageError_8.GatewayTimeoutError,
        GenericError: GetUsageError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    InvalidSdkConfigurationError: core_1.InvalidSdkConfigurationError,
    InvalidRegionOrHostError: core_1.InvalidRegionOrHostError,
    InvalidRegionError: core_1.InvalidRegionError,
    InvalidHostError: core_1.InvalidHostError,
};
